module.exports = __webpack_public_path__ + "static/media/try_now.0a7daa9b.jpg";